import {useEffect, useRef, useState} from 'react';

export const useDemoPulse = ({
  min = 80,
  max = 160,
  interval = 1000,
}: {
  min?: number;
  max?: number;
  interval?: number;
} = {}) => {
  const [pulse, setPulse] = useState(min);
  const isPulseIncreasing = useRef(true);

  useEffect(() => {
    const pulseTimer = setInterval(() => {
      if (pulse === min) {
        isPulseIncreasing.current = true;
      } else if (pulse === max) {
        isPulseIncreasing.current = false;
      }

      setPulse((pulse) => pulse + (isPulseIncreasing.current ? 1 : -1));
    }, interval);

    return () => clearInterval(pulseTimer);
  });

  return pulse;
};
